import React from "react";
import VisorPluginPlaceholder from "../../../_visor/components/canvas/VisorPluginPlaceholder";
import "./../_freeResponse.scss";
import { contentI18n as i18n } from "../../../common/content_language";
import { correctLongAnswer } from "../../../core/visor/correction_functions";
import { setRgbaAlpha } from "../../../common/common_tools";
import { getButtonText } from "../../../common/common_tools";
import AnswerButton from "./SubmitAnswerButton";
import QuizStatusLine from "../../../_visor/components/canvas/QuizStatusLine";
import { answerLength } from "../answerLength";
import { getInputStyles } from "../inputStyles";

/* eslint-disable react/prop-types */

export function FreeResponse() {
  return {
    getRenderTemplate: function (state, props) {
      let attempted = props.exercises && props.exercises.attempted;
      let score = props.exercises.score || 0;
      score = Math.round(score * 100) / 100;
      score =
        props.exercises.weight === 0
          ? i18n.t("FreeResponse.notCount")
          : score + "/" + props.exercises.weight;
      let showFeedback = attempted && state.showFeedback;
      let quizColor = state.quizColor || "rgba(250, 250, 250, 100)";

      let trueFeedbackContainer = props.boxes[props.id].sortableContainers["sc-TrueFeedback"];
      let trueFeedbackToolbar = trueFeedbackContainer?.children?.[0]
        ? props.toolbars[trueFeedbackContainer.children[0]]
        : null;

      let falseFeedbackContainer = props.boxes[props.id].sortableContainers["sc-FalseFeedback"];
      let falseFeedbackToolbar = falseFeedbackContainer?.children?.[0]
        ? props.toolbars[falseFeedbackContainer.children[0]]
        : null;

      let fixImgSvgStructure = (text) => {
        if (!text || typeof text !== "string") return text;
        let decoded = text;
        try {
          if (text.includes("%3C") || text.includes("%3E")) {
            decoded = decodeURIComponent(text);
          }
        } catch (e) {}

        decoded = decoded.replace(
          /<img\s*([^>]*?)>([\s\S]*?)<\/img>/gi,
          (match, attrs, content) => {
            if (content && content.trim() && content.includes("<svg")) {
              let spanAttrs = attrs ? attrs.trim() : "";
              if (spanAttrs && spanAttrs.includes("style=")) {
                spanAttrs = spanAttrs.replace(
                  /style\s*=\s*["']([^"']*)["']/i,
                  (styleMatch, styleContent) => {
                    let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                    return `style="${cleanStyle};display:inline-block;"`;
                  }
                );
              } else {
                spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
              }
              return `<span ${spanAttrs}>${content}</span>`;
            }
            return match;
          }
        );
        decoded = decoded.replace(/<img\s*([^>]*?)>\s*<svg/gi, (match, attrs) => {
          let spanAttrs = attrs ? attrs.trim() : "";
          if (spanAttrs && spanAttrs.includes("style=")) {
            spanAttrs = spanAttrs.replace(
              /style\s*=\s*["']([^"']*)["']/i,
              (styleMatch, styleContent) => {
                let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                return `style="${cleanStyle};display:inline-block;"`;
              }
            );
          } else {
            spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
          }
          return `<span ${spanAttrs}><svg`;
        });
        decoded = decoded.replace(/<\/svg>[\s\n]*<\/img>/gi, "</svg></span>");
        if (text.includes("%3C") || text.includes("%3E")) {
          try {
            return encodeURIComponent(decoded);
          } catch (e) {
            return decoded;
          }
        }
        return decoded;
      };

      let trueFeedbackText = fixImgSvgStructure(trueFeedbackToolbar?.state?.__text || "");
      let isDefaultTrueFeedbackMsg = false;

      let defaultTrueFeedbackMsg = "<p>" + i18n.t("MultipleChoice.TrueFeedbackMsg") + "</p>";

      if (
        trueFeedbackText === defaultTrueFeedbackMsg ||
        trueFeedbackText === encodeURI(defaultTrueFeedbackMsg) ||
        trueFeedbackText === encodeURI(defaultTrueFeedbackMsg + "\n") ||
        trueFeedbackText.includes(i18n.t("MultipleChoice.TrueFeedbackMsg"))
      ) {
        isDefaultTrueFeedbackMsg = true;
      }

      let checkEmptyTrueFeedback =
        (!trueFeedbackContainer?.children ||
          trueFeedbackContainer.children.length === 0 ||
          trueFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
          trueFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
          trueFeedbackToolbar?.state?.__text ===
            encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
        !isDefaultTrueFeedbackMsg;

      let falseFeedbackText = fixImgSvgStructure(falseFeedbackToolbar?.state?.__text || "");
      let isDefaultFalseFeedbackMsg = false;

      let defaultFalseFeedbackMsg = "<p>" + i18n.t("MultipleChoice.FalseFeedbackMsg") + "</p>";

      if (
        falseFeedbackText === defaultFalseFeedbackMsg ||
        falseFeedbackText === encodeURI(defaultFalseFeedbackMsg) ||
        falseFeedbackText === encodeURI(defaultFalseFeedbackMsg + "\n") ||
        falseFeedbackText.includes(i18n.t("MultipleChoice.FalseFeedbackMsg"))
      ) {
        isDefaultFalseFeedbackMsg = true;
      }

      let checkEmptyFalseFeedback =
        (!falseFeedbackContainer?.children ||
          falseFeedbackContainer.children.length === 0 ||
          falseFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
          falseFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
          falseFeedbackToolbar?.state?.__text ===
            encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
        !isDefaultFalseFeedbackMsg;

      // istrue drives which feedback (true/false) shows. Derive it from the
      // score set by checkAnswer (correctLongAnswer) so the feedback matches the
      // grade and stays case/accent-insensitive — a raw `==` here compared the
      // strings case-sensitively and disagreed with the score.
      let istrue = attempted && props.exercises.score > 0;

      // Tekrar ("Try Again") modunda sonuç, buton üstündeki durum satırıyla bildirilir.
      const isTryAgainMode =
        state.buttons === "tryAgain" ||
        state.buttons === i18n.t("MultipleChoice.tryAgain") ||
        state.buttons === "Try Again" ||
        state.buttons === "Tekrar Dene";
      const answered = !!props.exercises.currentAnswer && props.exercises.currentAnswer.length > 0;

      let minLength = state.minLength || 0;
      let maxLength = state.maxLength || 1000;
      let currentAnswerLength = answerLength(props.exercises.currentAnswer, state);
      let isValidLength = currentAnswerLength >= minLength && currentAnswerLength <= maxLength;

      // Create dynamic styles for textarea input in visor
      let inputStyles = getInputStyles(state);

      let buttonStyles = {
        backgroundColor: state.buttonBackgroundColor || "#FAFAFA",
        color: state.buttonTextColor || "#ffffff",
        borderColor: state.buttonBorderColor || "#FAFAFA",
        borderWidth: `${state.buttonBorderWidth || 1}px`,
        borderRadius: `${state.buttonBorderRadius || 4}px`,
        borderStyle: "solid",
        padding: `${state.buttonPadding || 8}px ${(state.buttonPadding || 8) * 1.5}px`,
        fontSize: `${state.buttonFontSize || 14}px`,
        fontWeight: state.buttonFontWeight || "normal",
        cursor: "pointer",
        margin: "2px",
        transition: "background-color 0.2s ease",
      };

      // Specific visual design for the submit/check-answer button
      let submitButtonStyles = {
        backgroundColor: "#FAFAFA",
        color: "#000000",
        borderRadius: "8px",
        height: "48px",
        padding: "0 24px",
        border: "1px solid #E5E5E5",
        cursor: "pointer",
        margin: "2px",
        fontSize: `${state.buttonFontSize || 14}px`,
        fontWeight: state.buttonFontWeight || "normal",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.2s ease",
      };

      return (
        <div
          className={"exercisePlugin freeResponsePlugin " + (attempted ? " attempted" : "")}
          style={{ "--q-btn-hover-bg": state.buttonHoverBackgroundColor || "#F0F0F0" }}
        >
          {" "}
          {/* <h1>Free Response</h1>*/}
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <VisorPluginPlaceholder {...props} key="0" pluginContainer={"Question"} />
              <textarea
                autoCapitalize="sentences"
                value={props.exercises.currentAnswer}
                disabled={attempted}
                spellCheck
                placeholder={""}
                aria-label={i18n.t("FreeResponse.Answer")}
                onChange={(e) => {
                  // Native maxLength counts whitespace, so with excludeSpaces the
                  // limit is enforced here instead (spaces stay typeable).
                  if (state.excludeSpaces && answerLength(e.target.value, state) > maxLength) {
                    return;
                  }
                  props.setAnswer(e.target.value);
                }}
                className="form-control textAreaQuiz textAreaQuizVisor dynamic-height"
                style={inputStyles}
                maxLength={state.excludeSpaces ? undefined : maxLength}
              />
              <div className="meter">
                <h1
                  style={{
                    marginTop: "4px",
                    marginBottom: "4px",
                    color: "GrayText",
                    fontSize: "12px",
                  }}
                >
                  {currentAnswerLength}/{maxLength}
                </h1>
              </div>
              {!attempted && props.exercises.currentAnswer && currentAnswerLength > maxLength ? (
                <div className={"tooManyCharacters"}>
                  {i18n.t("FreeResponse.TooMany") || "Too many characters"}
                </div>
              ) : null}
              {!attempted &&
              props.exercises.currentAnswer &&
              currentAnswerLength < minLength &&
              minLength > 0 ? (
                <div className={"tooFewCharacters"}>
                  {i18n.t("FreeResponse.TooFew") ||
                    `Minimum ${state.minLength || 0} characters required`}
                </div>
              ) : null}
            </div>
          </div>
          {istrue && !checkEmptyTrueFeedback ? (
            <div
              className={"row feedbackRow"}
              key={-2}
              style={{ display: showFeedback ? "block" : "none" }}
            >
              <div
                className={"col-xs-12 feedback"}
                role="status"
                aria-live="polite"
                style={{
                  color: /* quizColor */ "black",
                  borderColor: "#318533",
                  backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
                }}
              >
                <VisorPluginPlaceholder {...props} key="0" pluginContainer={"TrueFeedback"} />
              </div>
            </div>
          ) : null}
          {!istrue && !checkEmptyFalseFeedback ? (
            <div
              className={"row feedbackRow"}
              key={-2}
              style={{ display: showFeedback ? "block" : "none" }}
            >
              <div
                className={"col-xs-12 feedback"}
                role="status"
                aria-live="polite"
                style={{
                  color: /* quizColor */ "black",
                  borderColor: "#a31111",
                  backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <VisorPluginPlaceholder {...props} key="1232" pluginContainer={"FalseFeedback"} />
              </div>
            </div>
          ) : null}
          {isTryAgainMode && !state.showFeedback ? (
            <QuizStatusLine correct={istrue} visible={attempted && answered} />
          ) : null}
          <div className={"row"} key={7}>
            <AnswerButton
              onClick={(e) => {
                props.tryAgainHandler();
              }}
              disabled={false}
              hidden={
                !(
                  props.exercises.attempted &&
                  !!props.exercises.currentAnswer &&
                  props.exercises.currentAnswer.length > 0 &&
                  !istrue &&
                  (state.buttons === "tryAgain" ||
                    state.buttons === i18n.t("MultipleChoice.tryAgain") ||
                    state.buttons === "Try Again" ||
                    state.buttons === "Tekrar Dene")
                )
              }
              text={getButtonText(state.tryAgainText, "MultipleChoice.tryAgain")}
              fontSize={state.buttonFontSize}
              fontWeight={state.buttonFontWeight}
              settings={state}
            />
            <AnswerButton
              onClick={(e) => {
                props.seeAnswerHandler();
              }}
              disabled={false}
              hidden={
                istrue ||
                !props.exercises.attempted ||
                (state.buttons != i18n.t("MultipleChoice.seeAnswer") &&
                  state.buttons != "seeAnswer")
              }
              text={getButtonText(state.seeAnswerText, "MultipleChoice.seeAnswer")}
              fontSize={state.buttonFontSize}
              fontWeight={state.buttonFontWeight}
              settings={state}
            />
            <AnswerButton
              onClick={(e) =>
                isValidLength ? props.submitPage(props.currentView, props.id) : e.preventDefault()
              }
              disabled={!isValidLength}
              hidden={props.exercises.attempted}
              text={getButtonText(state.checkAnswerText, "MultipleChoice.checkAnswer")}
              fontSize={state.buttonFontSize}
              fontWeight={state.buttonFontWeight}
              settings={state}
            />
          </div>
          <div className={"exerciseScore"} style={{ color: quizColor }}>
            {score}
          </div>
        </div>
      );
    },
    checkAnswer(current, correct, state) {
      let minLength = state.minLength || 0;
      let maxLength = state.maxLength || 1000;

      let length = answerLength(current, state);
      if (!current || length < minLength || length > maxLength) {
        return 0;
      }

      return state.correct
        ? correctLongAnswer(current, correct, !state.characters)
        : current && current.length && current.length > 1
          ? 1
          : 0;
    },
  };
}
/* eslint-enable react/prop-types */
